import { t } from "./to-length.js";
var r = function r(_r) {
  return t(_r.length);
};
export { r as l };